import { ImageProperties, LogoRatio } from '@types';

export const bytesFileSize = 1000000;

export const allowedCSVSizeForGroupCreation = 2 * bytesFileSize; // MB

export const allowedDocumentFileSize = 5 * bytesFileSize; // MB

export const allowedImageSize = 5 * bytesFileSize; // MB

export const allowedImageSizeLabel = '5 MB';

export const excpectedEventLogoWidth = 1920;
export const excpectedEventLogoHeight = 1080;

export const DEFAULT_LOGO_RATIO: LogoRatio = '1:1';

export const logoCropAspectRatios: {
  key: LogoRatio;
  value: LogoRatio;
  ratio: number;
  imageProperties: ImageProperties;
}[] = [
  {
    key: '1:1',
    value: '1:1',
    ratio: 1,
    imageProperties: { width: 1, height: 1 }
  },
  {
    key: '2:1',
    value: '2:1',
    ratio: 2,
    imageProperties: { width: 2, height: 1 }
  }
];

export const getLogoCropAspectRatio = (key: string) =>
  logoCropAspectRatios.find((option) => option.key === key)?.ratio ?? 1;

export const toLogoRatio = (value?: string | null): LogoRatio =>
  logoCropAspectRatios.find((option) => option.key === value)?.key ??
  DEFAULT_LOGO_RATIO;

// Maps the BE `image_properties` ({ width, height }) to a supported ratio
export const getLogoRatioFromImageProperties = (
  imageProperties?: ImageProperties | null
): LogoRatio => {
  if (!imageProperties?.width || !imageProperties?.height)
    return DEFAULT_LOGO_RATIO;
  const ratio = imageProperties.width / imageProperties.height;
  return (
    logoCropAspectRatios.find((option) => option.ratio === ratio)?.key ??
    DEFAULT_LOGO_RATIO
  );
};

export const getImagePropertiesFromLogoRatio = (
  ratio: LogoRatio
): ImageProperties =>
  logoCropAspectRatios.find((option) => option.key === ratio)
    ?.imageProperties ?? { width: 1, height: 1 };

export const isWideLogoRatio = (ratio?: LogoRatio) => ratio === '2:1';

export const acceptedAttachmentFormats =
  'image/jpeg, image/png, image/jpg, video/*';

export const acceptedAttachmentSupportedDocumentFormats =
  'image/jpeg, image/png, image/jpg, application/pdf';
